<template>
  <div
    v-if="chartData.length > 0"
    class="verified-chart-container"
  >
    <div class="verified-chart-title">
      VERIFICATION ISSUES
    </div>
    <div class="flex-row align-center">
      <div class="flex-1">
        <highcharts :options="chartOptions" />
      </div>
      <div>
        <div
          v-for="(test, idx) in chartData"
          :key="idx"
          class="verified-chart-legend"
        >
          <div
            class="legend-color-square"
            :style="{ backgroundColor: colorList[idx] }"
          />
          <div class="legend-condition-group">
            {{ test.name }} ({{ test.y }})
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else-if="showNoIssues"
    class="verified-chart-no-issues-container"
  >
    <div class="verified-chart-title">
      VERIFICATION ISSUES
    </div>
    <img
      class="verified-chart-no-issues"
      src="@shared/assets/img/adoption/no-issues-chart.svg"
      alt="NO ISSUES"
    >
  </div>
</template>
<script>

import technicianMixin from '@shared/mixins/technicianMixin';

export default {
  name: 'VerificationPieChart',
  mixins: [technicianMixin],
  data() {
    return {
      colorList: ['#17244B', '#4C5781', '#939CBC', '#4979FF', '#2759E4'],
      chartData: [],
      showNoIssues: false,
    };
  },
  computed: {
    chartOptions() {
      return {
        credits: {
          enabled: false,
        },
        chart: {
          type: 'pie',
          backgroundColor: '#0B0F1E',
          height: 400,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0,
          spacingTop: 0,
        },
        title: '',
        plotOptions: {
          series: {
            allowPointSelect: false,
            cursor: 'auto',
          },
        },
        series: [
          {
            borderColor: null,
            name: 'Count',
            colorByPoint: true,
            dataLabels: {
              enabled: false,
            },
            data: this.chartData,
          },
        ],
      };
    },
  },
  watch: {
    selectedTech() {
      this.getChartData();
    },
  },
  mounted() {
    this.getChartData();
  },
  methods: {
    async getChartData() {
      // call endpoint
      const data = await this.$store.dispatch('getFailReasonsWithTech');
      if (data) {
        // build chartData
        const sortable = Object.fromEntries(Object.entries(data).sort(([, a], [, b]) => b - a));
        const keys = Object.keys(sortable);
        const chartData = [];
        let otherTotal = 0;
        for (let i = 0; i < keys.length; i += 1) {
          if (i >= 4) {
            const dataKey = keys[i];
            otherTotal += sortable[dataKey];
            delete sortable[dataKey];
          }
          sortable['All Other Issues'] = otherTotal;
        }

        if (keys.length > 0) {
          Object.keys(sortable).forEach((d, idx) => {
            chartData.push({
              name: d,
              y: sortable[d],
              color: this.colorList[idx],
            });
          });
        }
        if (chartData.length === 0) {
          this.showNoIssues = true;
        }
        this.chartData = chartData;
      }
    },
  },
};
</script>
<style lang="scss">

.verified-chart-container {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  margin-right: 20px;
  .verified-chart-title {
    font-size: 0.875rem;
    font-weight: 700;
    color: $WHITE;
    white-space: nowrap;
  }
  .verified-chart-legend {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    .legend-color-square {
      border: 1px solid #8990A2;
      border-radius: 8px;
      width: 29px;
      height: 30px;
      margin-right: 10px;
    }
    .legend-condition-group {
      color: $WHITE;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
.verified-chart-no-issues-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 20px;
  .verified-chart-title {
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    color: $WHITE;
    text-align: left;
    margin-bottom: 15px;
  }
  .verified-chart-no-issues {
    width: 317px;
    height: 317px;
  }
}
</style>
